import { EXPORT_ERROR_MESSAGE } from '@data/components/basic/Table/types';
import type { useMetricsTableV2Api } from '@data/hooks/api/use-metrics-table-v2-api/use-metrics-table-v2-api';
import type { ProductCode } from '@data/main';
import { exportTableToCSV } from '@data/utils/export-table-to-csv';
import { filterTableData } from '@data/utils/filter-table-data';
import formatDate from '@data/utils/format-date';
import type { ColumnRule } from '@data/utils/resolve-columns';
import { useCallback } from 'react';

export function useExportToCSVHandler(
  refetchExportData: ReturnType<typeof useMetricsTableV2Api>['refetch'],
  tableColumns: ColumnRule[],
  edApp: ProductCode,
  reportPath: string | undefined
) {
  return useCallback(async () => {
    const { data: exportData, error } = await refetchExportData();
    if (error) throw error;
    if (!exportData) throw new Error(EXPORT_ERROR_MESSAGE);

    const { visibleColumns: exportColumns, visibleRows: exportRows } =
      filterTableData(exportData, tableColumns, edApp);

    exportTableToCSV(
      exportColumns,
      exportRows,
      `${reportPath ?? 'report'}_${edApp}_${formatDate(new Date())}.csv`
    );
  }, [refetchExportData, tableColumns, edApp, reportPath]);
}
